import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { confirmAlert } from "react-confirm-alert";
import { findByComunicado, save, remove } from "./api-comunicado-aluno";
import AlunoFindDialog from "../../Aluno/AlunoFindDialog";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { errorToast } from "../../../util/ToastUtil";
import Loading from "../../UI/Loading";

export default function ComunicadoAlunoTable({ comunicado }) {
  const [comunicadoAlunos, setComunicadoAlunos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    findByComunicado(comunicado.codigo)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else {
          setComunicadoAlunos(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [comunicado.codigo]);

  const handleAlunoSelected = (aluno) => {
    if (!aluno) return;
    save({ comunicado, aluno }).then((data) => {
      if (!data) return;
      if (data.error) {
        errorToast(`Aluno ${aluno.nome} já cadastrado.`);
        return;
      }
      setComunicadoAlunos((prevState) => [...prevState, data]);
    });
  };

  const handleDelete = (comunicadoAluno) => {
    confirmAlert({
      title: "Alerta",
      message: `Deseja remover ${comunicadoAluno.aluno.nome} do comunicado?`,
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            remove(comunicadoAluno.codigo).then((data) => {
              if (data?.error) {
                errorMessage(data.message);
                return;
              }
              setComunicadoAlunos((prevState) =>
                prevState.filter((ca) => ca.codigo !== comunicadoAluno.codigo),
              );
            });
          },
        },
        { label: "Não", onClick: () => {} },
      ],
    });
  };

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2 }}>
      <AlunoFindDialog openSearch={open} setOpenSearch={setOpen} setAluno={handleAlunoSelected} />

      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} p={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="subtitle1" fontWeight={600}>
            Alunos
          </Typography>
          <Chip size="small" label={comunicadoAlunos.length} />
        </Stack>
        {!comunicado.enviado && (
          <Button size="small" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
            Adicionar
          </Button>
        )}
      </Stack>
      <Divider />

      {isLoading ? (
        <Box py={4}>
          <Loading size={28} description="Carregando Alunos..." />
        </Box>
      ) : comunicadoAlunos.length === 0 ? (
        <Typography variant="body2" color="text.secondary" textAlign="center" py={4} px={2}>
          Nenhum aluno adicionado.
        </Typography>
      ) : (
        <List dense disablePadding sx={{ maxHeight: 420, overflowY: "auto" }}>
          {comunicadoAlunos.map((ca) => (
            <ListItem
              key={ca.codigo}
              divider
              secondaryAction={
                !comunicado.enviado && (
                  <Tooltip title="Remover aluno">
                    <IconButton edge="end" size="small" onClick={() => handleDelete(ca)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )
              }
            >
              <ListItemText primary={ca.aluno.nome} />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
}
